export class PutawayStrategyInfo {
    putawayStrategyID: string;
    putawayStrategyName: string;
    constructor() {
        this.putawayStrategyID = null;
        this.putawayStrategyName = null; 
    }
}